import { useSelector } from 'react-redux';
import { useUser } from 'global/hooks/useUser';

// Single source of truth for "is the current session a hashed view?"
//   active           — true when banner should show + close/Share should hide
//   hash             — raw hash from the original /share/:hash URL (for re-redeeming after login)
//   scope            — { kind, id, courseId? }
//   expiresAt        — raw string from backend (date or datetime)
//   hashToken        — bearer token redeemed from the share link
//   hasNormalAccess  — backend says: this logged-in user can see this content normally
//   loggedIn         — whether a normal user session also exists
export const useHashView = () => {
  const hashAuth = useSelector((s) => s.hashAuth);
  const { loggedIn } = useUser();

  const hasToken = !!hashAuth?.hashToken;
  const hasNormalAccess = !!hashAuth?.hasNormalAccess;

  return {
    active: hasToken && !hasNormalAccess,
    hasToken,
    hash: hashAuth?.hash || null,
    scope: hashAuth?.scope || null,
    expiresAt: hashAuth?.expiresAt || null,
    hashToken: hashAuth?.hashToken || null,
    hasNormalAccess,
    loggedIn,
    status: hashAuth?.status || 'idle',
    error: hashAuth?.error || null,
  };
};
